module.exports = __webpack_public_path__ + "img/bobuw_bobocoin.gm.402315b.png";